<div [ngBusy]="{ busy: pLoading, message: ('common.pleaseWait' | translate) }">
  @if (allowToChangeCountry) {
    <div class="form-group">
      <label class="fw-bold"
             [ngClass]="{'font-md': compact, 'label-xl-to-md': !compact}">
        {{ 'orderProcess.payment.invoiceCompanySearcher.selectCountry' | translate }}
      </label>

      <ui-select
        [placeholder]="'orderProcess.payment.invoiceCompanySearcher.selectCountry' | translate"
        [extraClasses]="'w-100'"
        [items]="countryCodeItems"
        [(model)]="countryCodeItem"
        (modelChange)="orgNumber = ''; foundCompany = null; searchCompanyError = ''">
      </ui-select>
    </div>
  }

  @if (countryCodeItem) {
    <div class="form-group">
      @if (!compact || showCompanySearcherLabel) {
        <label class="fw-bold"
               [ngClass]="{'font-md': compact, 'label-xl-to-md': !compact}">
          {{ 'orderProcess.payment.invoiceCompanySearcher.enterCompanySearchQuery' | translate }}
        </label>
      }

      <ui-search-bar
        [debounce]="300"
        [minLength]="3"
        [itemsSourceFn]="searchCompanyByQuery.bind(this)"
        [itemTemplate]="itemTemplate"
        [selectedItem]="selectedItem"
        [styleType]="'slim'"
        [showLoading]="true"
        [showSearchIcon]="false"
        [cleanOnSelect]="false"
        [placeholder]="'orderProcess.payment.invoiceCompanySearcher.enterCompanySearchQueryPlaceholder' | translate"
        [nothingFoundTemplate]="noResults && nothingFound"
        [disabled]="!allowToChangeCompany"
        (onNothingFound)="noResults = $event"
        (onSelected)="companySelected($event)">
      </ui-search-bar>
    </div>
  }

  @if (allowToContinueWithOrgNumber) {
    @if (searchCompanyError) {
      <div class="mb-3">
        @if (searchCompanyError === COMPANY_SEARCH_ERRORS.NOT_FOUND) {
          <ui-message class="text-danger d-block" [type]="'error'">
            {{ 'orderProcess.payment.invoiceCompanySearcher.companyNotFound' | translate }}
          </ui-message>
        }

        @if (searchCompanyError === COMPANY_SEARCH_ERRORS.ENK_NOT_ALLOWED) {
          <ui-message class="text-danger d-block" [type]="'error'">
            {{
              (isForPayment
                ? 'orderProcess.payment.invoiceCompanySearcher.pleaseUsePrivateMethod'
                : 'orderProcess.payment.invoiceCompanySearcher.privateCompanyNotAllowed') | translate
            }}
          </ui-message>
        }
      </div>
    }

    @if (showCancel) {
      <div class="text-end">
        <button class="btn btn-link text-dark p-0" (click)="onCancel.emit()">
          {{ 'common.cancel' | translate }}
        </button>
      </div>
    }
  }
</div>

<ng-template #itemTemplate let-company="item">
  @if (compact) {
    <div class="fw-bold">{{ company.name }}</div>
    <div class="font-xs">{{ company.id }}</div>
  } @else {
    <span class="fw-bold">{{ company.name }}</span>&nbsp;&nbsp;<small class="font-xs">{{ company.id }}</small>
  }
</ng-template>

<ng-template #nothingFound>
  <div class="no-company-found font-sm">
    {{ 'orderProcess.payment.invoiceCompanySearcher.nothingFound' | translate }}
  </div>
</ng-template>
